(() => {
  const dialog = document.querySelector('[data-links-reviews]');
  const openers = document.querySelectorAll('[data-links-reviews-open]');
  if (!dialog || !openers.length) return;

  // Loox's product total is independent of the PDP's featured review selection.
  document.querySelectorAll('[data-links-review-count]').forEach((node) => {
    const total = Number(node.dataset.reviewTotal);
    if (Number.isFinite(total) && total > 0) node.textContent = `${total.toLocaleString('es-MX')} reseñas de clientes`;
  });

  const closeButton = dialog.querySelector('[data-links-reviews-close]');
  const summary = dialog.querySelector('[data-reviews-summary]');
  const status = dialog.querySelector('[data-reviews-status]');
  const grid = dialog.querySelector('[data-reviews-grid]');
  const filters = dialog.querySelector('[data-reviews-filters]');
  const more = dialog.querySelector('[data-reviews-more]');
  const scrollArea = dialog.querySelector('[data-reviews-scroll]');
  const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  const batchSize = 18;
  let reviews = null;
  let loading = null;
  let filter = 'all';
  let shown = 0;
  let opener = null;
  let closeTimer = 0;
  let animationTimer = 0;

  const safeImageUrl = (value) => {
    if (typeof value !== 'string' || !value.trim()) return '';
    const raw = value.trim();
    if (!/^https:\/\//i.test(raw) && !/^\/\//.test(raw)) return '';
    try {
      const url = new URL(raw, window.location.href);
      return url.protocol === 'https:' ? url.href : '';
    } catch (_) {
      return '';
    }
  };

  const formatDate = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
    if (!match) return '';
    return `${Number(match[3])} ${months[Number(match[2]) - 1] || ''} ${match[1]}`;
  };

  const addText = (parent, className, text) => {
    const node = document.createElement('span');
    node.className = className;
    node.textContent = text;
    parent.appendChild(node);
    return node;
  };

  const makeCard = (review) => {
    const card = document.createElement('article');
    card.className = 'agc-links-review';
    const imageUrl = safeImageUrl(review.img);
    if (imageUrl) {
      const image = document.createElement('img');
      image.className = 'agc-links-review__photo';
      image.src = imageUrl;
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      card.appendChild(image);
    }
    const content = document.createElement('div');
    content.className = 'agc-links-review__content';
    const top = document.createElement('div');
    top.className = 'agc-links-review__top';
    addText(top, 'agc-links-review__name', String(review.n || 'Cliente de Aguacero'));
    if (review.src === 'ml' || review.v === true || review.v === 1) {
      const badge = document.createElement('span');
      badge.className = 'agc-links-review__badge';
      if (review.src === 'ml') {
        const logoUrl = safeImageUrl(dialog.dataset.mlLogoUrl);
        if (logoUrl) {
          const logo = document.createElement('img');
          logo.src = logoUrl;
          logo.alt = 'Mercado Libre';
          logo.width = 14;
          logo.height = 10;
          logo.loading = 'lazy';
          badge.appendChild(logo);
        }
      }
      badge.appendChild(document.createTextNode('Compra verificada'));
      top.appendChild(badge);
    }
    content.appendChild(top);
    const meta = document.createElement('div');
    meta.className = 'agc-links-review__meta';
    const rating = Math.max(0, Math.min(5, Math.round(Number(review.r) || 0)));
    const stars = addText(meta, 'agc-links-review__stars', '★★★★★'.slice(0, rating));
    stars.setAttribute('aria-label', `${rating} de 5 estrellas`);
    const offStars = addText(stars, '', '★★★★★'.slice(rating));
    offStars.setAttribute('aria-hidden', 'true');
    addText(meta, 'agc-links-review__date', formatDate(review.d));
    content.appendChild(meta);
    const text = document.createElement('p');
    text.className = 'agc-links-review__text';
    text.textContent = String(review.t || '');
    content.appendChild(text);
    card.appendChild(content);
    return card;
  };

  const filteredReviews = () => reviews.filter((review) => {
    const hasPhoto = Boolean(safeImageUrl(review.img));
    return filter === 'all' || (filter === 'photo' ? hasPhoto : !hasPhoto);
  });

  const renderBatch = () => {
    const list = filteredReviews();
    const fragment = document.createDocumentFragment();
    list.slice(shown, shown + batchSize).forEach((review) => fragment.appendChild(makeCard(review)));
    shown = Math.min(shown + batchSize, list.length);
    grid.appendChild(fragment);
    more.hidden = shown >= list.length;
    if (!more.hidden) more.textContent = `Cargar ${Math.min(batchSize, list.length - shown)} más`;
    if (!list.length) showStatus('No hay reseñas en este filtro. Prueba con otra opción.');
  };

  const showStatus = (message, canRetry = false) => {
    status.replaceChildren();
    const copy = document.createElement('p');
    copy.textContent = message;
    status.appendChild(copy);
    if (canRetry) {
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.textContent = 'Intentar de nuevo';
      retry.addEventListener('click', () => loadReviews(true));
      status.appendChild(retry);
    }
    status.hidden = false;
    grid.hidden = true;
    more.hidden = true;
  };

  const renderReviews = () => {
    summary.textContent = 'Selección de opiniones de clientes';
    filters.querySelectorAll('button').forEach((button) => { button.disabled = reviews.length === 0; });
    if (!reviews.length) {
      summary.textContent = 'Selección no disponible';
      showStatus('No hay opiniones disponibles en esta selección.');
      return;
    }
    status.hidden = true;
    grid.hidden = false;
    grid.replaceChildren();
    shown = 0;
    renderBatch();
  };

  const loadReviews = (retry = false, visible = dialog.open) => {
    if (reviews) {
      if (visible) renderReviews();
      return Promise.resolve(reviews);
    }
    if (loading && !retry) return loading;
    if (visible) {
      showStatus('Cargando reseñas reales…');
      summary.textContent = 'Cargando reseñas reales…';
    }
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 8000);
    loading = fetch(dialog.dataset.reviewsUrl, { signal: controller.signal, credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((data) => {
        if (!Array.isArray(data)) throw new Error('Formato inválido');
        reviews = data.filter((item) => item && typeof item === 'object');
        if (dialog.open || reviews.length) renderReviews();
        return reviews;
      })
      .catch(() => {
        if (dialog.open) {
          summary.textContent = 'No pudimos cargar las reseñas';
          showStatus('Hubo un problema al cargar las reseñas.', true);
        }
        loading = null;
      })
      .finally(() => window.clearTimeout(timeout));
    return loading;
  };

  const openDialog = (event) => {
    opener = event.currentTarget;
    window.clearTimeout(closeTimer);
    window.clearTimeout(animationTimer);
    dialog.classList.remove('is-closing');
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('agc-links-reviews-locked');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!dialog.open || dialog.classList.contains('is-closing')) return;
        dialog.classList.add('is-open', 'is-animating');
        closeButton.focus({ preventScroll: true });
        animationTimer = window.setTimeout(() => dialog.classList.remove('is-animating'), 650);
      });
    });
    loadReviews();
  };

  const closeDialog = () => {
    if (!dialog.open || dialog.classList.contains('is-closing')) return;
    window.clearTimeout(animationTimer);
    dialog.classList.remove('is-open');
    dialog.classList.add('is-closing', 'is-animating');
    closeTimer = window.setTimeout(() => {
      dialog.classList.remove('is-closing', 'is-animating');
      dialog.close();
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 330);
  };

  openers.forEach((button) => button.addEventListener('click', openDialog));
  closeButton.addEventListener('click', closeDialog);
  more.addEventListener('click', renderBatch);
  filters.addEventListener('click', (event) => {
    const button = event.target.closest('[data-review-filter]');
    if (!button || button.disabled || button.getAttribute('aria-pressed') === 'true') return;
    filter = button.dataset.reviewFilter;
    filters.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    grid.replaceChildren();
    status.hidden = true;
    grid.hidden = false;
    shown = 0;
    scrollArea.scrollTo({ top: 0, behavior: 'smooth' });
    renderBatch();
  });
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeDialog(); });
  dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
  dialog.addEventListener('close', () => {
    window.clearTimeout(closeTimer);
    window.clearTimeout(animationTimer);
    dialog.classList.remove('is-open', 'is-closing', 'is-animating');
    document.documentElement.classList.remove('agc-links-reviews-locked');
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  });
  const prefetch = () => loadReviews(false, false);
  if ('requestIdleCallback' in window) window.requestIdleCallback(prefetch, { timeout: 2000 });
  else window.setTimeout(prefetch, 1000);
})();
